
  (function() {
    function initCustomMenuHover() {
      document.querySelectorAll('.block__custom-menu').forEach(function(menu) {
        if (menu.dataset.hoverInitialized) return;
        menu.dataset.hoverInitialized = 'true';

        var navLinks = menu.querySelectorAll('.block__custom-menu-nav-item a');
        var menuItems = menu.querySelectorAll('.block__custom-menu-item');
        var menuList = menu.querySelector('.block__custom-menu_list');

        navLinks.forEach(function(link) {
          function activatePanel() {
            var href = link.getAttribute('href');
            var targetId = link.getAttribute('data-panel') || (href && href.startsWith('#') ? href.substring(1) : null);
            if (targetId) {
              var targetItem = menu.querySelector('#' + CSS.escape(targetId));
              
              if (targetItem) {
                navLinks.forEach(function(l) { l.classList.remove('active'); });
                menuItems.forEach(function(i) { i.classList.remove('active'); });

                link.classList.add('active');
                targetItem.classList.add('active');
              }
            } else {
              navLinks.forEach(function(l) { l.classList.remove('active'); });
              link.classList.add('active');
              menuItems.forEach(function(i) { i.classList.remove('active'); });
            }
          }
          link.addEventListener('mouseenter', activatePanel);
          link.addEventListener('focus', activatePanel);
        });

        if (menuList) {

          menuList.addEventListener('mouseenter', function() {
            var activeLink = menuList.querySelector('.block__custom-menu-nav-item a.active');
            if (!activeLink) {
              var firstLink = navLinks[0];
              if (firstLink) {
                firstLink.classList.add('active');
                var href = firstLink.getAttribute('href');
                var __pid = firstLink.getAttribute('data-panel') || (href && href.startsWith('#') ? href.substring(1) : null);
                if (__pid) {
                  var targetItem = menu.querySelector('#' + CSS.escape(__pid));
                  if (targetItem) {
                    targetItem.classList.add('active');
                  }
                }
              }
            }
          });
        }
      });
    }

    function initCustomMobileMenuClick() {
      document.querySelectorAll('.block__custom-mobile-menu-nav').forEach(function(nav) {
        if (nav.dataset.clickInitialized) return;
        nav.dataset.clickInitialized = 'true';

        var navLinks = nav.querySelectorAll('.block__custom-mobile-menu-nav-item > a.has_menu');
        var menuItems = nav.querySelectorAll('.block__custom-mobile-menu-item');

        // Sync initial active state
        nav.querySelectorAll('.block__custom-mobile-menu-nav-item > a.active').forEach(function(activeLink) {
          var target = activeLink.nextElementSibling;
          if (target && target.classList.contains('block__custom-mobile-menu-item')) {
            target.classList.add('active');
          }
        });

        navLinks.forEach(function(link) {
          link.addEventListener('click', function(e) {
            e.preventDefault();
            var targetItem = link.nextElementSibling;
            if (targetItem) {
              var isAlreadyActive = targetItem.classList.contains('active');

              // Collapse all other mobile menu items and deactivate other links
              navLinks.forEach(function(l) { l.classList.remove('active'); });
              menuItems.forEach(function(i) { i.classList.remove('active'); });

              // If it wasn't active, activate it now
              if (!isAlreadyActive) {
                link.classList.add('active');
                targetItem.classList.add('active');
              }
            }
          });
        });
      });
    }

    function initAll() {
      initCustomMenuHover();
      initCustomMobileMenuClick();
    }

    window.slInitMenu = initAll;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll(); 
    }
  })();


(function(){
  if (window.slmMobileAccordion) return;
  window.slmMobileAccordion = true;

  var DRAWER = '.mobile-navigation-drawer';

  function itemOf(el) {
    var t = el.closest('.navigation__children-toggle, .navigation__link');
    if (!t) return null;
    if (!t.closest(DRAWER)) return null;
    var li = t.parentElement;
    if (!li || !li.classList.contains('navigation__item')) return null;
    var tier1 = li.parentElement;
    if (!tier1 || !tier1.classList.contains('navigation__tier-1')) return null;
    if (!li.querySelector(':scope > .navigation__tier-2-container')) return null;
    return li;
  }

  function collapse(li) {
    li.classList.remove('slm-open', 'navigation__item--open');
    li.querySelectorAll(':scope > .navigation__link, :scope > .navigation__children-toggle').forEach(function(a){a.setAttribute('aria-expanded','false');});
    var panel = li.querySelector(':scope > .navigation__tier-2-container');
    if (panel) panel.style.top = '';
  }

  function onClick(e) {
    if (e.button !== undefined && e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var target = e.target instanceof Element ? e.target : null;
    if (!target) return;

    var li = itemOf(target);
    if (!li) return;                       // pozycje bez podmenu dzialaja jak zwykle linki

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var drawer = li.closest(DRAWER);
    var wasOpen = li.classList.contains('slm-open') || li.classList.contains('navigation__item--open');

    // zwin wszystkie
    if (drawer) {
      drawer.classList.remove('mobile-navigation-drawer--child-open');
      drawer.querySelectorAll('.navigation__tier-1 > .navigation__item').forEach(collapse);
    }
    if (!wasOpen) {
      li.classList.add('slm-open');
      li.querySelectorAll(':scope > .navigation__link, :scope > .navigation__children-toggle').forEach(function(a){a.setAttribute('aria-expanded','true');});
    }
  }

  // tylko click w fazie przechwytywania — preventDefault na pointerdown
  // blokowalby przewijanie gestem rozpoczetym na wierszu menu
  document.addEventListener('click', onClick, true);
})();
